module.exports = __webpack_public_path__ + "img/note.77a7eaf0.png";